import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    max-width: 738px;
  `}
`;

export const ComponentWrapper = styled(Wrapper)`
  margin: 48px 0;
`;

export const HeadWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const Image = styled.img`
  width: 220px;
  user-select: none;
`;

export const IconCircle = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 50%;
    height: 32px;
    width: 32px;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: ${theme.v2.font.lineHeight.description};
    margin: 8px 0;
    max-width: 657px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0 0px 0;
`;

export const HelpLabel = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    margin: 0;
    padding-top: 40px;
    a {
      font-weight: ${theme.v2.font.weights.regular};
      text-decoration: underline;
    }
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
      a {
        font-size: ${theme.v2.font.sizes.xxs};
        display: contents;
      }
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  align-self: end;
  display: flex;
  justify-content: center;
  position: relative;
  margin-top: 40px;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;
